import { render } from "./SupplierAnswer.vue?vue&type=template&id=218fe3e8"
import script from "./SupplierAnswer.vue?vue&type=script&lang=js"
export * from "./SupplierAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__